const feetToCentimeter = (feet: any): number => {
  return Number(feet) * 30.48;
};
const inchToCentimeter = (inch: any): number => {
  return Number(inch) * 2.54;
};
const stoneToKilo = (stone: any): number => {
  return Number(stone) * 6.35029;
};
const poundToKilo = (pound: any): number => {
  return Number(pound) * 0.45359237;
};

export const UnitsUtil = {
  feetToCentimeter,
  inchToCentimeter,
  stoneToKilo,
  poundToKilo,
};
